import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '@lib/useTypedTranslation';

import { InvalidPage } from '../components/errors/invalidPage';
import { AnomalyHistory } from '../containers/core/anomaly/anomalyHistory';
import { useWorldRoutes } from './parts/allWorldRoutes';
import { useMemo } from 'react';

export const CoreAnomalyRoute = () => {
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const anomalyId = searchParams.get('anomalyId');
  const routes = useWorldRoutes();
  const { t } = useTranslation('redirect');

  const anomalyNotFound = <InvalidPage
    message={t('ANOMALY_NOT_FOUND')}
    redirect={{
      message: t('REDIRECT_TO_ANOMALIES'),
      path: routes.core.anomalies
    }}
  />;

  if (!anomalyId) {
    return anomalyNotFound;
  }

  return (
    <AnomalyHistory anomalyId={anomalyId} />
  );
};
